import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  Event,
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { SOCIAL_NETWORKS } from '@shared/constants/social-networks';
import { MenuItem } from '@shared/interfaces/menu-item.interface';
import { filter } from 'rxjs';
import menuJson from '../../../../../assets/menu-items.json';
import { NotificationComponent } from '../notification/notification.component';
import { AnalyticsHeaderService } from '@core/services/google-analytics/trackers/header/ga-header.service';

@Component({
  selector: 'app-header',
  imports: [NgClass, RouterLink, RouterLinkActive, NotificationComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  currentPage: MenuItem | undefined;
  isSidebarVisible = false;
  openNotifications = false;
  newNotifications = false;
  menuItems = menuJson;
  isMyAccountActive = false;
  notificationIconSrc = 'assets/icons/notification.svg';
  readonly SOCIAL_NETWORKS = SOCIAL_NETWORKS;

  constructor(
    private readonly _router: Router,
    private readonly _authService: AuthService,
    private readonly _gAnalytics: AnalyticsHeaderService,
  ) {}

  ngOnInit(): void {
    this.updateCurrentPage(this._router.routerState.snapshot.url);
    this._router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentPage(event.urlAfterRedirects);
      });
  }

  updateCurrentPage(url: string) {
    this.currentPage = this.findMenuItemByRoute(
      this.menuItems.items,
      url,
    ) as MenuItem;
    this.isMyAccountActive = url.includes('/mi-cuenta');
  }

  findMenuItemByRoute(items: MenuItem[], url: string): MenuItem | null {
    for (const item of items) {
      if (item.route && url.includes(item.route)) {
        return item;
      }
    }
    return null;
  }

  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  showNotifications() {
    this._gAnalytics.trackNotificationClick();
    this.openNotifications = true;
  }

  navigateToPage(menuItem: MenuItem) {
    this._router.navigate([`${menuItem.route}`]);
    this.toggleSidebar();
  }

  onMouseEnterNotifications() {
    this.notificationIconSrc = 'assets/icons/filled-notification.svg';
  }

  onMouseLeaveNotifications() {
    this.notificationIconSrc = 'assets/icons/notification.svg';
  }

  signOut() {
    console.log('Signing out...');
    this._authService.signOut();
  }

  toggleUnViewedNotification(unViewedNotification: boolean) {
    this.newNotifications = unViewedNotification;
  }

  hasPermission(category: string): boolean {
    return this._authService.hasPermission(category);
  }
}
